export const ColorColumns = [
    "CRMField",
    "RLField",
    "PONumber",
    "Style",
    "POField",
    "CRMField"
  ]